import React from 'react';
import PropTypes from 'prop-types';

import { SideNavContext } from '../index.context';

import * as Styles from './index.styles';

const { StyledSection } = Styles;

export const SideNavSection = ({ title, mobileOnly, desktopOnly }) => (
    <SideNavContext.Consumer>
        {({ mobile, collapsedMenu }) =>
            ((mobile && mobileOnly) ||
                (!mobile && desktopOnly) ||
                (!mobileOnly && !desktopOnly)) && (
                <StyledSection title={title}>
                    {collapsedMenu && desktopOnly ? '' : title}
                </StyledSection>
            )
        }
    </SideNavContext.Consumer>
);

SideNavSection.propTypes = {
    title: PropTypes.string.isRequired,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
};

SideNavSection.defaultProps = {
    mobileOnly: false,
    desktopOnly: false,
};

SideNavSection.Styles = Styles;
